// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"351":"a36b30cc","939":"f2525f3b"}[chunkId] + ".chunk.js";
};